const UNSAFE_REDIRECT_CHARACTERS = /[\\\u0000-\u001f\u007f]/u

export function getSafeRedirectUrl(
    value: string | null | undefined,
    fallback: string,
): string {
    const candidate = value?.trim()
    if (!candidate || !candidate.startsWith('/') || candidate.startsWith('//')) return fallback
    if (UNSAFE_REDIRECT_CHARACTERS.test(candidate)) return fallback

    try {
        const base = new URL('https://fitro.invalid')
        const resolved = new URL(candidate, base)
        if (resolved.origin !== base.origin) return fallback
        const normalized = `${resolved.pathname}${resolved.search}${resolved.hash}`
        if (!normalized.startsWith('/') || normalized.startsWith('//')) return fallback
        return normalized
    } catch {
        return fallback
    }
}
